<template>
    <div>
        <pxkeji-rightHeader />
        <a-tabs default-active-key="alipay">
            <a-tab-pane key="news" tab="新闻授权" @change="onnewsChange">
                <pxkeji-btn style="float: right;margin-right:50px" name="新闻授权" size="small" @click="showNews()"
                    type="primary" />
                <div class="mainWrapper clearfix">
                    <div class="articleMeauleft" :style="height">
                        <a-tree :replaceFields="newsCategoryreplaceFields" :treeData="newstreeDataCategory"
                            @select="this.onnewsSelect" />
                    </div>
                    <div class="articleMainRight">
                        <div class="pxkeji-right-box">
                            <a-table :columns="newslist.newsColumns" rowKey="id" :pagination="newslist.pagination"
                                @change="onNewsChange" :dataSource="newslist.datas" :loading="isloading"
                                :locale="{ emptyText: '暂无数据' }">
                            </a-table>
                        </div>
                    </div>
                    <a-modal :title="newsChoose.title" v-model="newsChoose.visible" width="80%" :footer="false"
                        destroyOnClose :maskClosable="false">
                        <newsChoose @callbackMethod="chooseNewsback" :id="newsChoose.id" :adminTel="newsChoose.adminTel" />
                    </a-modal>
                </div>
            </a-tab-pane>
            <a-tab-pane key="course" tab="课程授权" force-render @change="oncourseChange">
                <a-row>
                    <a-col :span="5"></a-col>
                    <a-col :span="13">
                        <a-form :label-col="{ span: 8 }" :wrapperCol="{ span: 16 }">
                            <a-row>
                                <a-col :span="8">
                                    <a-form-item label="课程名称：">
                                        <a-input placeholder="请输入" v-model="coursewhere.keyword.courseName" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-item label="添加方式：">
                                        <a-select placeholder="选择添加方式" v-model="coursewhere.keyword.isSys" allowClear>
                                            <a-select-option value="1">总站授权</a-select-option>
                                            <a-select-option value="0">自主上传</a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="8">
                                    <a-form-item label="课程来源：">
                                        <a-select defaultValue="lucy" v-model="coursewhere.keyword.courseFrom" allowClear>
                                            <a-select-option :value="info.id" v-for="(info, index) in courseFromList"
                                                :key="index">{{ info.itemName }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-form>
                    </a-col>
                    <a-col :span="6">
                        <pxkeji-btn style="float: right;margin-right:30px;margin-top:5px" name="课程授权" size="small"
                            @click="showCourse()" type="primary" />
                        <pxkeji-btn v-if="courselist.selectedRowKeys.length > 0"
                            style="float: right;margin-right:6px;margin-top:5px" name="批量更新" size="small"
                            @click="courselist.updateCourse.visible = true" type="danger" />
                        <pxkeji-btn style="float: right;margin-right:6px;margin-top:5px" name="搜索课程" size="small"
                            @click="searchCourse" type="primary" />
                    </a-col>
                </a-row>

                <div class="mainWrapper clearfix">
                    <div class="articleMeauleft" :style="height">
                        <a-tree :replaceFields="coursereplaceFields" :treeData="classList" @select="this.onCourseselect" />
                    </div>
                    <div class="articleMainRight">
                        <div class="pxkeji-right-box">
                            <a-table :columns="courselist.coursecolumns" rowKey="id" :pagination="courselist.pagination"
                                @change="onCourseSelect" :dataSource="courselist.datas" :loading="isloading"
                                :row-selection="{ selectedRowKeys: courselist.selectedRowKeys, onChange: onSelectChange }"
                                :locale="{ emptyText: '暂无数据' }">
                                <span slot="status" slot-scope="status">
                                    <a-tag v-if="status == 1" color="green">已发布</a-tag>
                                    <a-tag v-else-if="status == -1" color="red">未发布</a-tag>
                                    <a-tag v-else-if="status == 2" color="red">未开始</a-tag>
                                    <a-tag v-else-if="status == 3" color="green">直播中</a-tag>
                                    <a-tag v-else-if="status == 4" color="gray">已结束</a-tag>
                                    <a-tag v-else color="gray">已删除</a-tag>
                                </span>
                                <span slot="old_id" slot-scope="old_id">
                                    <a-tag v-if="old_id" color="blue">总站授权</a-tag>
                                    <a-tag v-else color="green">自主上传</a-tag>
                                </span>
                                <span slot="action" slot-scope="action">
                                    <a-button v-if="action.old_id" type="primary" size="small"
                                        @click="showUpdateClassHour(action)">更新课件</a-button>
                                    <span v-else>--</span>
                                </span>
                            </a-table>
                        </div>
                    </div>
                    <a-modal :title="courseChoose.title" v-model="courseChoose.visible" width="70%" :footer="false"
                        destroyOnClose :maskClosable="false">
                        <courseChoose @callbackMethod="chooseCourseback" :id="courseChoose.id"
                            :adminTel="courseChoose.adminTel" />
                    </a-modal>
                    <a-modal :title="classHour.title" v-model="classHour.visible" width="80%" :footer="false" destroyOnClose
                        :maskClosable="false">
                        <classHourEmpower :courseId="classHour.courseId" :dataZone="classHour.dataZone"
                            :oldId="classHour.oldId" @callback="empowerClassFinish"></classHourEmpower>
                    </a-modal>
                    <a-modal v-model="courselist.updateCourse.visible" title="选择更新内容" centered @ok="updateSelCourse">
                        <a-radio-group v-model="courselist.updateCourse.contentTypeKeys">
                            <a-radio style="display:block;line-height: 60px;"
                                v-for="(item, index) in courselist.contentType" :value="item.label">
                                {{ item.name }}
                            </a-radio>
                        </a-radio-group>
                    </a-modal>
                    <a-modal v-model="subsite.visible" title="选择要更新的站点" width="80%" :footer="false">
                        <DataZone @confirm="confirmChoose"></DataZone>
                    </a-modal>
                </div>
            </a-tab-pane>
            <a-tab-pane key="subject" tab="题库授权" force-render @change="onsubjectChange">
                <pxkeji-btn style="float: right;margin-right:50px" name="题库授权" size="small" @click="showSubject()"
                    type="primary" />
                <div class="mainWrapper clearfix">
                    <div class="articleMeauleft" :style="height">
                        <a-tree :replaceFields="newsCategoryreplaceFields" :treeData="subjecttreeDataCategory"
                            @select="this.onsubjectSelect" />
                    </div>
                    <div class="articleMainRight">
                        <div class="pxkeji-right-box">
                            <a-table :columns="subjectlist.subjectcolumns" rowKey="id" :pagination="subjectlist.pagination"
                                @change="onsubjectpageChange" :dataSource="subjectlist.datas" :loading="isloading"
                                :locale="{ emptyText: '暂无数据' }">
                            </a-table>
                        </div>
                    </div>
                    <a-modal :title="subjectChoose.title" v-model="subjectChoose.visible" width="70%" :footer="false"
                        destroyOnClose :maskClosable="false">
                        <subjectChoose @callbackMethod="chooseSubjectback" :id="subjectChoose.id"
                            :adminTel="subjectChoose.adminTel" />
                    </a-modal>
                </div>
            </a-tab-pane>
        </a-tabs>
        <!--        </div>-->

    </div>
</template>
<script>
import newsChoose from "./newsChoose.vue";
import subjectChoose from "./subjectChoose.vue";
import courseChoose from "./courseChoose.vue"; //选择课程
import classHourEmpower from "./classHourEmpower.vue";//选择授权课件
import DataZone from "./dataZone.vue";//选择站点
const newsColumns = [
    {
        dataIndex: "articlecategoryName",
        key: "articlecategoryName",
        align: "center",
        title: "分类名称"
    },
    {
        dataIndex: "title",
        key: "title",
        align: "center",
        title: "标题"
    },
    {
        dataIndex: "addtime",
        key: "addtime",
        align: "center",
        title: "添加时间"
    },
];
const coursecolumns = [
    {
        dataIndex: "id",
        key: "id",
        align: "center",
        title: "课程编号"
    },
    {
        dataIndex: "name",
        key: "name",
        align: "center",
        title: "课程名称"
    },
    {
        dataIndex: "typeName",
        key: "typeName",
        align: "center",
        title: "分类"
    },
    {
        dataIndex: "hour_count",
        key: "hour_count",
        align: "center",
        title: "学时"
    },
    {
        dataIndex: "presentPrice",
        key: "presentPrice",
        align: "center",
        title: "价格"
    },
    {
        dataIndex: "courseFromName",
        key: "courseFromName",
        align: "center",
        title: "来源",
    },
    {
        dataIndex: "status",
        key: "status",
        align: "center",
        title: "状态",
        scopedSlots: { customRender: "status" }
    },
    {
        dataIndex: "old_id",
        key: "old_id",
        align: "center",
        title: "添加方式",
        scopedSlots: { customRender: "old_id" }
    },
    {
        title: "操作",
        key: "action",
        align: "center",
        scopedSlots: { customRender: "action" },
    },

];
const subjectcolumns = [
    {
        dataIndex: "categoryName",
        key: "categoryName",
        align: "center",
        title: "分类"
    },
    {
        dataIndex: "difficult",
        key: "difficult",
        align: "center",
        title: "难度等级",
        width: 200,
        scopedSlots: { customRender: "difficult" }
    },
    {
        dataIndex: "questContent",
        key: "questContent",
        align: "center",
        title: "题目内容"
    },
    {
        dataIndex: "optionConf",
        key: "optionConf",
        align: "center",
        title: "题目选项"
    },
    {
        dataIndex: "answer",
        key: "answer",
        align: "center",
        title: "答案"
    },
];
var that;
export default {
    name: "initDataList",
    props: {
        id: String,
        adminTel: String
    },
    data() {
        return {
            isloading: false,
            loadingTip: "加载中...",
            height: {
                height: ""
            },
            newswhere: {
                //查询条件
                keyword: {
                    //搜索条件
                    name: "",
                    title: "",
                    categoryId: []
                }
            },
            coursewhere: {
                //查询条件
                keyword: {
                    //搜索条件
                    courseName: "",
                    typeId: null,
                    isSys: ""
                }
            },
            newsCategoryreplaceFields: { children: "list", title: "name", key: "id" },
            coursereplaceFields: { children: "children", title: "name", key: "id" },
            newstreeDataCategory: [],
            subjecttreeDataCategory: [],
            newslist: {
                newsColumns, //表头
                datas: [], //数据
                pagination: {
                    //分页器
                    showQuickJumper: true,
                    hideOnSinglePage: true,
                    total: 0,
                    showTotal: function (total, range) {
                        return "共 " + total + " 条";
                    },
                    current: 1, //页码
                    defaultPageSize: 10 //页容
                }
            },
            classList: [],
            classHour: {
                title: "更新课程资源",
                visible: false,
                courseId: "",
                oldId: "",
                dataZone: ""
            },
            courselist: {
                coursecolumns, //表头
                datas: [], //数据
                pagination: {
                    //分页器
                    showQuickJumper: true,
                    hideOnSinglePage: true,
                    total: 0,
                    showTotal: function (total, range) {
                        return "共 " + total + " 条";
                    },
                    current: 1, //页码
                    defaultPageSize: 10 //页容
                },
                selectedRowKeys: [],//选中的列
                updateCourse: {
                    visible: false,
                    contentTypeKeys: 1,
                },
                contentType: [
                    { name: "课程名称、图片、介绍、教师", label: 1 }, { name: "价格", label: 2 }, { name: "课程来源(仅支持hc,xndx,by,zsd之间的相互转换)", label: 3 }
                ]
            },
            subjectlist: {
                subjectcolumns, //表头
                datas: [], //数据
                pagination: {
                    //分页器
                    showQuickJumper: true,
                    hideOnSinglePage: true,
                    total: 0,
                    showTotal: function (total, range) {
                        return "共 " + total + " 条";
                    },
                    current: 1, //页码
                    defaultPageSize: 10 //页容
                }
            },
            subjectwhere: {
                //查询条件
                keyword: {
                    //搜索条件
                    question: "",
                    categoryId: []
                }
            },
            subjectTypeIds: "",
            newsallSelectRows: [],
            newsselectRows: [], //选中项编号
            courseChoose: {
                visible: false,
                id: 0,
                title: "课程授权",
                type: 0,
                adminTel: "",
            },
            subjectChoose: {
                visible: false,
                id: 0,
                title: "题库授权",
                type: 0,
                adminTel: "",
            },
            newsChoose: {
                visible: false,
                id: 0,
                title: "新闻授权",
                type: 0,
                adminTel: "",
            },
            subsite: {
                visible: false,
            },
            courseFromList: [],
        };
    },
    components: {
        courseChoose: courseChoose,
        subjectChoose: subjectChoose,
        newsChoose: newsChoose,
        classHourEmpower: classHourEmpower,
        DataZone: DataZone
    },
    mounted: function () {
        this.$nextTick(function () {
            that = this;
            this.getNewsTree();
            this.getCourseType();
            this.GetCourseList();
            this.getCourseFromList();
            this.getsubjectTree();
            this.GetsubjectList();
        });
    },
    watch: {},
    methods: {
        /**
         * 获取课程来源
         */
         getCourseFromList() {
            this.isloading = true;
            this.$api.dictionaryItem
                .getDictionaryItem(2)
                .then(res => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                        this.courseFromList = res.data;
                    } else {
                        this.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
        },
        /**
         * 选择子站的课程ID
         * @param {*} e 
         */
        onSelectChange(e) {
            this.courselist.selectedRowKeys = e;
        },
        /**
         * 点击批量更新确认按钮
         */
        updateSelCourse() {
            this.subsite.visible = true;
            this.courselist.updateCourse.visible = false;
        },
        /**
         * 选择更新站点
         */
        confirmChoose(e) {
            var data = {
                dataZones: e.dataZones,
                courseIds: this.courselist.selectedRowKeys,
                contentType: this.courselist.updateCourse.contentTypeKeys,
            }
            this.isloading = true;
            this.$api.course.updateSubSiteCourseBaseInfo(data).then(res => {
                that.isloading = false;
                if (res.errorCode == "0000") {
                    this.subsite.visible = false;
                    this.$message.success(res.errorMsg)
                    this.GetCourseList();
                } else {
                    this.$message.error(res.errorMsg)
                }
            });
        },

        error(msg) {
            this.$error({
                title: "提示",
                content: msg == undefined ? "服务器异常" : msg,
                okText: "返回",
                centered: true,
                onOk() {
                    that.$emit("callbackMethod");
                },
            });
        },
        //新闻----------
        GetNewsList() {
            //获取列表
            this.isloading = true;
            this.$api.article
                .pageList(
                    this.newslist.pagination.current,
                    this.newslist.pagination.defaultPageSize,
                    this.newswhere.keyword.title,
                    this.newswhere.keyword.name,
                    this.newswhere.keyword.categoryId,
                    null, null, null, null, null,
                    this.id
                )
                .then(res => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                        this.newslist.datas = res.data.records;
                        this.newslist.pagination.total = Number(res.data.total);
                        res.data.records.forEach(function (item, index) {
                            if (item.optionConf) {
                                var opArr = [];
                                for (let i in JSON.parse(item.optionConf)) {
                                    opArr.push(i + ":" + JSON.parse(item.optionConf)[i]);
                                }
                                item.optionConf = opArr.join(" ");
                            }
                        });
                    } else {
                        this.$message.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
        },
        newsTreeChange(val) {
            this.newswhere.keyword.categoryId = val;
        },
        onnewsSelect(selectedKeys, info) {
            that.newswhere.keyword.categoryId = selectedKeys[0];
            this.GetNewsList();
        },
        getNewsTree() {
            this.$api.cms.articlecategory
                .getTree(this.id)
                .then(res => {
                    if (res.errorCode == this.$msg.responseCode.success) {
                        // res.data.forEach(function(item, index) {
                        //     item.id = item.id;
                        // });
                        this.newstreeDataCategory = res.data;
                    } else {
                        this.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
        },
        onNewsChange(page) {
            //页面切换回调
            this.newslist.pagination.current = page.current;
            this.GetNewsList();
        },

        onCourseselect(selectedKeys, info) {
            that.coursewhere.keyword.typeId = selectedKeys[0];
            this.GetCourseList();
        },
        searchList() {
            this.list.pagination.current = 1;
            this.GetNewsList();
        },
        onnewsChange() {

        },
        showNews() {
            this.newsChoose.visible = true;
            this.newsChoose.id = this.id;
            this.newsChoose.adminTel = this.adminTel;
        },
        chooseSubjectback() {
            this.subjectChoose.visible = false;
            this.getNewsTree();
            this.getCourseType();
            this.GetCourseList();
            this.getsubjectTree();
            this.GetsubjectList();
        },
        chooseCourseback() {
            this.courseChoose.visible = false;
            this.getNewsTree();
            this.getCourseType();
            this.GetCourseList();
            this.getsubjectTree();
            this.GetsubjectList();
        },
        chooseNewsback() {
            this.newsChoose.visible = false;
            this.getNewsTree();
            this.getCourseType();
            this.GetCourseList();
            this.getsubjectTree();
            this.GetsubjectList();
        },
        //新闻---------------------------------------------------------------------------------------------------------------------------------
        //课程---------------------------------------------------------------------------------------------------------------------------------
        oncourseChange() {
            this.courselist.pagination.current = 1;
            this.getCourseType();
            this.GetCourseList();
        },
        /**
         * 搜索课程
         */
        searchCourse() {
            this.GetCourseList();
        },
        /**
         * 更新课件
         * @param {*} course 
         */
        showUpdateClassHour(course) {
            this.classHour.courseId = course.id;
            this.classHour.dataZone = this.id;
            this.classHour.visible = true;
            this.classHour.oldId = course.old_id;
        },
        showCourse() {
            this.courseChoose.visible = true;
            this.courseChoose.id = this.id;
            this.courseChoose.adminTel = this.adminTel;
        },
        onsubjectChange() {
            this.subjectlist.pagination.current = 1;
            this.getsubjectTree();
            this.GetsubjectList();
        },
        onCourseSelect(page) {
            //页面切换回调
            this.courselist.pagination.current = page.current;
            this.GetCourseList();
        },
        getCourseType() {
            this.isloading = true;
            this.$api.courseType
                .getTreeByColumnId('', '', this.id)
                .then(res => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                        this.classList = res.data;
                    } else {
                        that.$message.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
        },
        GetCourseList() {
            this.isloading = true;
            this.$api.course
                .getPageList(
                    this.courselist.pagination.current,
                    this.courselist.pagination.defaultPageSize,
                    this.coursewhere.keyword.typeId,
                    this.coursewhere.keyword.courseName,
                    this.coursewhere.keyword.courseFrom,
                    0,
                    null,
                    '',
                    this.id,
                    this.coursewhere.keyword.isSys,
                )
                .then(res => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                        this.courselist.datas = res.data.records;
                        this.courselist.pagination.total = Number(res.data.total);

                    } else {
                        this.$message.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
        },
        //题库----------------------------------------------------------------------
        showSubject() {
            this.subjectChoose.visible = true;
            this.subjectChoose.id = this.id;
            this.subjectChoose.adminTel = this.adminTel;
        },
        onsubjectSelect(selectedKeys, info) {
            that.subjectwhere.keyword.categoryId = selectedKeys[0];
            this.GetsubjectList();
        },
        GetsubjectList() {
            //获取列表
            this.isloading = true;
            this.$api.subject
                .getPageList(
                    this.subjectlist.pagination.current,
                    this.subjectlist.pagination.defaultPageSize,
                    this.subjectwhere.keyword.question,
                    this.subjectwhere.keyword.categoryId,
                    this.id
                )
                .then(res => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                        this.subjectlist.datas = res.data.records;
                        this.subjectlist.pagination.total = Number(res.data.total);
                        res.data.records.forEach(function (item, index) {
                            if (item.optionConf) {
                                var opArr = [];
                                for (let i in JSON.parse(item.optionConf)) {
                                    opArr.push(i + ":" + JSON.parse(item.optionConf)[i]);
                                }
                                item.optionConf = opArr.join(" ");
                            }
                        });
                    } else {
                        this.$message.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
        },
        treeChange(val) {
            this.newswhere.keyword.categoryId = val;
        },
        getsubjectTree() {
            this.$api.questioncategory
                .getTree(this.id)
                .then(res => {
                    if (res.errorCode == this.$msg.responseCode.success) {
                        res.data.forEach(function (item, index) {
                            item.id = Number(item.id);
                        });
                        this.subjecttreeDataCategory = res.data;
                    } else {
                        this.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
        },
        onsubjectpageChange(page) {
            //页面切换回调
            this.subjectlist.pagination.current = page.current;
            this.GetsubjectList();
        },
        subjectsearchList() {
            this.list.pagination.current = 1;
            this.GetsubjectList();
        },
        /**
         * 总站更新子站课件资源
         * @param {*} e 
         */
        empowerClassFinish(e) {
            this.classHour.visible = false;
            this.$message.success("课件授权完成");
        }

    },
};
</script>
<style>
.articleMeauleft {
    width: 20%;
    padding: 0 1%;
    min-height: 700px;
    background: #fff;
    float: left;
    margin-top: 10px;
}

.articleMainRight {
    width: 80%;
    float: right;
}

.ant-form-item {
    margin-bottom: 0 !important;
}

.ant-form-item-label {
    line-height: 30px;
}
</style>


